import { ExtractedEntities } from "../types";
import { buildConversationScript } from "../shared/script_builder";

export function render(entities: ExtractedEntities): string {
  return buildConversationScript(entities);
}
